<template>
  <div class="messages" style="margin-top: 120px;">
    <div class="top-nav">
      <v-btn text @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon> Back
      </v-btn>
    </div>
    <div class="top-nav justify-center">
      <h3 class="blank-header primary--text">Messsages</h3>
    </div>
    <v-flex>
      <div class="d-flex justify-center" v-if="route_messages($route.params.route).length < 1">There are currently no messages for this page.</div>
      <v-expansion-panel>
        <v-expansion-panel-content
                v-for="(message,i) in route_messages($route.params.route)"
                :key="i"
        >
          <template v-slot:header>
            <div><strong>{{ message.title }}</strong></div>
          </template>
          <v-card>
            <v-card-text v-html="message.body"></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    mounted() {
    },
    data: () => ({

    }),
    computed: {
      ...mapGetters({
        route_messages: 'messages/route_messages',
      })
    }
  }
</script>

<style lang="scss">
  .messages {
    width: 100%;
    .v-expansion-panel__header {
      padding: 12px 15px !important;
      font-size: 18px;
    }
  }

</style>
